import { Component } from 'react'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('Page error:', error, info.componentStack)
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '60vh', padding: 40, textAlign: 'center',
        }}>
          <div style={{ fontSize: 32, marginBottom: 16 }}>⚠️</div>
          <div style={{ fontFamily: 'var(--fd)', fontSize: 18, fontWeight: 700, color: 'var(--navy)', marginBottom: 8 }}>
            Something went wrong
          </div>
          <div style={{ fontFamily: 'var(--fu)', fontSize: 13, color: 'var(--hint)', marginBottom: 24, maxWidth: 400 }}>
            {this.state.error.message || 'An unexpected error occurred on this page.'}
          </div>
          <button
            onClick={() => this.setState({ error: null })}
            style={{
              padding: '9px 20px', background: 'var(--accent-soft)', color: 'var(--accent)', border: '1px solid color-mix(in srgb, var(--accent) 40%, transparent)',
              borderRadius: 8, fontFamily: 'var(--fu)', fontSize: 13, fontWeight: 600, cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
